<template>
  <v-card outlined class="mt-4 deep-orange lighten-1 display-card">
    <v-card-title class="section-title">{{ title }}</v-card-title>
    <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
    <v-card-text>
      <v-card elevation="2" class="white">
        <v-card-text>
          <slot />
          <v-btn class="primary mt-6" :disabled="!canAdd" @click="$emit('add')">
            เพิ่มข้อมูลการแสดง
          </v-btn>
        </v-card-text>
      </v-card>
      <v-divider class="my-3 white" />
      <v-simple-table dense>
        <thead>
          <tr>
            <th>ลำดับ</th>
            <th v-for="column in columns" :key="column.value">{{ column.text }}</th>
            <th>ลบ</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="rows.length === 0">
            <td :colspan="columns.length + 2" class="pa-3">
              <v-alert type="warning" text dense class="mb-0">ไม่มีข้อมูลการแสดงผลในตาราง</v-alert>
            </td>
          </tr>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{ index + 1 }}.</td>
            <td v-for="column in columns" :key="column.value">{{ row[column.value] }}</td>
            <td>
              <v-btn icon small color="red" :aria-label="`ลบรายการที่ ${index + 1}`" @click="$emit('remove', index)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TeachTableDisplayPanel",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    columns: { type: Array, required: true },
    rows: { type: Array, required: true },
    canAdd: { type: Boolean, default: false },
  },
};
</script>
